import { createContext, ReactNode, useContext } from 'react';
import { Machine } from '../gql/generated';

/** A tab of the machine detail. */
export interface MachineDetailTab {
  value: string;
  label: string;
  render: (machine: Machine) => ReactNode;
}

/**
 * Replaces the tabs of every machine detail below it. The Interpom demo sets
 * the tabs of Arthur's design, whose data EDMS does not deliver yet.
 */
export const MachineDetailTabsContext = createContext<
  MachineDetailTab[] | null
>(null);

/** The tabs that replace the detail's own, or null to keep its own. */
export function useMachineDetailTabs(): MachineDetailTab[] | null {
  return useContext(MachineDetailTabsContext);
}
